import { Link } from 'react-router';
import styles from './Tab.scss';

export function Tab( { label, path, isActiveTab, backgroundHighlight } ) {
    const testID = `hyp-tab-${label.toLowerCase()}`;
    let tabStyle;
    
    if (isActiveTab) {
        tabStyle = backgroundHighlight ? styles.activeBackground : styles.active;
    } else {
        tabStyle = styles.tab;
    }
    
    return (
        <Link data-test-id={testID} className={tabStyle} to={path} data-cy="Tab-return">{label}</Link>       
    );
}